import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api, fmtDT } from "../lib/api";
import { Btn, Card, Empty } from "../components/kit";

export default function Alerts() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {
      /* keep previous list */
    }
  };
  useEffect(() => {
    load();
  }, []);
  const readAll = async () => {
    await api.post("/notifications/read").catch(() => {});
    load();
  };
  return (
    <div className="space-y-3 fade-in">
      <div className="flex items-center justify-between">
        <h1 className="font-head text-3xl uppercase font-bold">Alerts</h1>
        <Btn variant="outline" size="sm" onClick={readAll} data-testid="alerts-read-all-btn">Mark all read</Btn>
      </div>
      {!items.length && <Empty icon={Bell} title="No alerts yet" />}
      {items.map((n) => (
        <Card key={n.id} className={`cursor-pointer ${n.read ? "opacity-60" : ""}`} onClick={() => nav(n.url)} data-testid="alert-item">
          <div className="flex justify-between gap-3">
            <div className="font-medium">{n.title}</div>
            <div className="text-xs font-mono text-neutral-500 shrink-0">{fmtDT(n.at)}</div>
          </div>
          <div className="text-sm text-neutral-400 mt-1">{n.body}</div>
        </Card>
      ))}
    </div>
  );
}
